import script from "./SnapshotPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./SnapshotPopup.vue?vue&type=script&setup=true&lang=js"

import "./SnapshotPopup.vue?vue&type=style&index=0&id=75beb62d&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75beb62d"]])

export default __exports__